<div class="container">
  <h1 i18n="@@myAccount">My account</h1>
  <div class="page-container">
    <div>
      <div class="profile-pic">
        <img [src]="getPicture()">
      </div>

      <input #FileSelectInputDialog (change)="retrieveImage($event)" accept='image/*' class="d-none"
             type="file"/>
      <div class="profile-pic-buttons-container">
        <div (click)="selectPicture($event)" class="upload-button">
          <div *ngIf="isUploadImageLoading" class="spinner-container">
            <div class="spinner-border text-white" role="status">
            </div>
          </div>
          <div *ngIf="!isUploadImageLoading" class="customer-picture">
            <img src="assets/upload-icon.svg">
          </div>
          <p *ngIf="!isUploadImageLoading"  i18n="@@upload">Upload</p>
        </div>

        <div (click)="removeProfilePic()" *ngIf="this.customer?.profilePictureURL" class="delete-button">
          <img src="assets/trash-icon.svg">
        </div>
      </div>
    </div>

    <div>
      <div>
        <div class="user-field-title"><p i18n>Your Name</p></div>
        <div class="user-field-value">
          <p>{{ customer?.name ?? "" }}</p>
          <div (click)="changeUserName()" class="change">
            <p i18n="@@change">Change</p>
          </div>
        </div>
      </div>
      <div>
        <div class="user-field-title"><p i18n="@@emailLabel">Email</p></div>
        <div class="user-field-value">
          <p>{{ customer?.email ?? "" }}</p>
        </div>
      </div>
    </div>
    <div>
      <div>
        <div class="user-field-title"><p i18n>Mobile Number</p></div>
        <div class="user-field-value">
          <p>{{ getPhoneNumber() }}</p>
          <div (click)="changeMobileNumber()" class="change"><p i18n="@@change">Change</p></div>
        </div>
      </div>
      <div>
        <div class="user-field-title"><p i18n="@@passwordLabel">Password</p></div>
        <div class="user-field-value">
          <p>**************</p>
          <div (click)="changePassword()" class="change"><p i18n="@@change">Change</p></div>
        </div>
      </div>
    </div>
  </div>
</div>
